import React from 'react';
import { Checkbox } from './ui/checkbox';

export const ContratTvaToggle = ({ checked, onChange, totalHt, format }) => {
  const tva = checked ? Math.round(totalHt * 0.18) : 0;
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-4 space-y-2" data-testid="contrat-tva-box">
      <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-slate-800">
        <Checkbox checked={checked} onCheckedChange={(v) => onChange(!!v)} data-testid="contrat-tva-checkbox" />
        Ajouter la TVA (18%)
      </label>
      <div className="text-sm text-slate-600 flex justify-between"><span>Total HT</span><span data-testid="contrat-total-ht">{format(totalHt)}</span></div>
      {checked && (
        <div className="text-sm text-slate-600 flex justify-between"><span>TVA 18%</span><span data-testid="contrat-tva-montant">{format(tva)}</span></div>
      )}
      <div className="text-base font-bold text-slate-900 flex justify-between border-t pt-2">
        <span>{checked ? 'Total TTC' : 'Total'}</span><span data-testid="contrat-total-ttc">{format(totalHt + tva)}</span>
      </div>
    </div>
  );
};
